import { Location } from "@angular/common";
import {
  Component,
  HostListener,
  OnInit,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { ServicioGeneral } from "../_services/servicio-general.service";
import { TokenStorageService } from "../_services/token-storage.service";


export interface DataModel {
  menuListado: string;
}


@Component({
  selector: "app-board-admin",
  templateUrl: "./board-admin.component.html",
  styleUrls: ["./board-admin.component.scss"],


})
export class BoardAdminComponent implements OnInit {

  API_URL: string = environment.API_URL;
  //content?: string;
  content: any = [];
  myForm: UntypedFormGroup;
  currentUser: any;
  currentEnv: string;
  totalElements: number = 0;
  getScreenWidth: any;
  sidebarOpen: boolean = false;
  showDiv = {
    crear: false,
    actualizar: false,
    eliminar: false
  }

  Listado: any = [];
  miData: any = [];
  menuListado: any = [];
  menuPerfil: any = [];

  seleccionado: string;
  miid;

  TipoFirma: any = [];
  EstadoElaboracion: any = [];
  EstadoDocumento: any = [];
  Origenes: any = [];
  TipoDocumentales: any = [];
  SubTipoDocumentales: any = []

  formData: UntypedFormGroup;

  menuOption: String;

  formVisible: boolean;
  formAsuntoVisible
  formLibroVisible
  procVisible: boolean;
  autoVisible: boolean;
  textProcedimientos: string;
  hijosList: any = [];
  menuPadre: any = [];
  selectedOption: any = {};
  environment = environment;
  public reloadComponent: boolean = false;

  constructor(
    private servicioGeneral: ServicioGeneral,
    private formBuilder: UntypedFormBuilder,
    private token: TokenStorageService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router
  ) {
    this.buildForm();
    this.currentEnv = environment.environment;
  }

  public buildForm() {
    this.myForm = this.formBuilder.group({
      opcionesmenu: [null],
    });
  }

  setSelectedOption(valueSelected) {
    if (this.currentUser.rol.includes(valueSelected.rol.id)) {
      this.selectedOption = valueSelected;
    } else {
      this.selectedOption = { action: -1, nombre: 'Home' };
    }

  }
  redirectUrl(menu) {
    window.open('#/' + menu.url);
  }

  public obtenerContenido() {

    return this.myForm.controls["opcionesmenu"].value;
  }

  public onSubmit(data: DataModel) { }

  ngOnInit(): void {

    const queryParams = this.route.snapshot.queryParams;

    // Verificar si 'action' está presente en los queryParams
    if ('action' in queryParams) {
      this.removeParamFromURL(window.location.href, 'action')

    }
    this.currentUser = this.token.getUser();
    this.verificarUserRol();
    this.formData = new UntypedFormGroup({
      organo: new UntypedFormControl(),
      tipoFirma: new UntypedFormControl(),
      firmaServidor: new UntypedFormControl(),
      origen: new UntypedFormControl(),
      estadoElaboracion: new UntypedFormControl(),
      tipoDocumental: new UntypedFormControl(),
    });

    this.getMenuLateralList();
    this.getScreenWidth = window.innerWidth;
/*     this.servicioGeneral.getCaducidadesObs();
 */  }


  removeParamFromURL(url, param) {
    const [path, searchParams] = url.split('?');
    const newSearchParams = searchParams
      ?.split('&')
      .filter((p) => !(p === param || p.startsWith(`${param}=`)))
      .join('&');

    this.location.replaceState(
      this.router.createUrlTree(
        [],
        { queryParams: [] }
      ).toString()
    );
    // return newSearchParams ? `${path}?${newSearchParams}` : path;
  }



  getMenuLateralList() {

    return this.servicioGeneral.getMenuLateralList().subscribe((data) => {
      this.menuListado = data['Menu']
      for (let index = 0; index < this.menuListado.length; index++) {
        const element = this.menuListado[index];
        element.isCollapsed = false;
        element.isRowActive = false;
      }
      this.selectedOption = { action: -1, nombre: 'Home' };
      this.route.queryParams
        .subscribe(params => {
          if (params["action"] && params["action"] != 20) {
            let menu = this.menuListado.filter(mL => mL.action == params["action"]);
            if (menu != null && menu.length > 0) {
              this.setSelectedOption(menu[0]);
            } else {
              let submenu = null;
              let submenuSelected = null;
              let parent = null;
              for (let i = 0; i < this.menuListado.length; i++) {
                submenu = this.menuListado[i].listadoHijos.filter((smL) => smL.action == params["action"])
                if (submenu != null && submenu.length > 0) {
                  parent = this.menuListado[i];
                  submenuSelected = submenu[0];
                  parent.isCollapsed = true;
                  parent.isRowActive = true;

                  this.setSelectedOption(submenuSelected);

                  return
                }
              }
            }

          } else {
            if (params["action"] == 20) {
              this.setSelectedOption(this.menuListado.filter(mL => mL.action == 20)[0]);
            } else {
              this.selectedOption = { action: -1, nombre: 'Home' };
            }
          }
        });
    });
  }

  changeCollapse(menu) {
    let div = document.getElementById('desplegable' + menu.id);
    menu.isRowActive = !div.classList.contains('show');
  }


  esrol: any = [];
  verificarUserRol() {
    this.esrol = this.currentUser.rol;
    return this.esrol;
  }

  scrollIf(isDown) {
    if (isDown) {
      window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' });
    } else {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }
  }

  showMenu(submenu, currentUser) {
    let canShow = false;
    if (submenu.rol != null && currentUser.rol.includes(submenu.rol['id'])) {
      canShow = true;
      if (submenu.action == 3 || submenu.action == 30 || submenu.action == 32 || submenu.action == 33 || submenu.action == 34) {
        canShow = false;
      }
    }
    return canShow;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
  }

  getFirstLetter(nombre: string) {
    return nombre.charAt(0).toUpperCase();
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }
}


